<template>
	<el-dialog :visible.sync="chakanpdf" width="0px" append-to-body class="el-dialog-chakanpdf"
		:before-close="handleClickchakanpdf">

		<div>
			<div class="x-tc-page-bg">
				<div class="x-tc-title douyuFont">
					<div v-if="chakanpdfName!=''">
						{{chakanpdfName}}
					</div>
					<div v-else>
						查看详情
					</div>
				</div>
				<div class="x-close" @click="closeClick"></div>
				<div class="x-tc-cnt">
					<template v-if="this.chakanpdfId==null || this.chakanpdfId=='' || this.chakanpdfId=='null'">
						<span style="
												color: #218fce;
												width: 100%;
												height: 100%;
												display: flex;
												justify-content: center;
												align-items: center;
												flex-direction: column;
												font-size: 19px;
												text-align: center
												">暂无文件</span>
					</template>
					<template v-else>
						<iframe :src="this.chakanpdfId" class="pdf_iframe"></iframe>
					</template>

				</div>

			</div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name: "index",
		components: {},
		props: {
			chakanpdfId: {
				type: String,
				default: ''
			},
			chakanpdfName: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				// 弹出层标题
				chakanpdf: true,



			}
		},

		created() {

		},

		mounted() {
			console.log("传的PDF路径：")
			console.log(this.chakanpdfId)
			console.log("传的PDF名字：")
			console.log(this.chakanpdfName)
		},
		beforeDestroy() {

		},
		methods: {

			handleClickchakanpdf() {
				this.$emit('on-point')
			},

			closeClick() {
				this.$emit('on-point')
			},


		}
	}
</script>
<style scoped>
	.pdf_iframe {
		width: 1085px;
		height: 750px;
	}




	.shang {
		width: 1085px;
		height: 194px;
		margin-top: 10px;
		margin-left: 0px;
		float: left;
		/* border: #fff solid 1px; */
	}

	.xia {
		width: 1085px;
		height: 546px;
		margin-top: 0px;
		margin-left: 0px;
		float: left;
	}

	.x-tc-page-bg {
		background: url("~@/assets/common/tanChuang.png") no-repeat;
		background-size: 100% 100%;
		width: 1132px;
		height: 813px;
		position: fixed;
		top: 100px;
		left: 400px;
		z-index: 99999;
	}

	.x-tc-title {
		font-size: 22px;
		position: absolute;
		left: 80px;
		top: 15px;
		color: white;
		letter-spacing: 0px;
	}

	.x-close {
		width: 50px;
		height: 50px;
		position: absolute;
		right: 30px;
		cursor: pointer;
	}


	.x-tc-cnt {
		width: 1085px;
		height: 750px;
		position: absolute;
		left: 22px;
		top: 58px;
		overflow: hidden;
	}
</style>

<style>
	.x-tc-page-bg {
		background: url("~@/assets/common/tanChuang.png") no-repeat !important;
		background-size: 100% 100% ! important;
		width: 1132px !important;
		height: 813px !important;
		position: fixed !important;
		top: 50% !important;
		left: 50% !important;
		z-index: 99999 !important;
		margin-left: -566px !important;
		margin-top: -406px !important;
	}
</style>